import { UtilizationEventDto } from '@core/mappers/bonus/dtos/BetEligibilityDto';
import UtilizationEvent from '@core/models/bonus/UtilizationEvent';

export function transformUtilizationEvent(dto: UtilizationEventDto): UtilizationEvent {
    return {
        id: dto.EventId,
        status: dto.BetStatus,
        betOnSide: dto.BetOnSide,
        inPlay: dto.InPlay,
    };
}
